import { useState } from 'react'

type IUseStash<U> = [U[], (items: U[]) => void]
/**
 * Description: Maintains a fresh list of unique items when used with paginated data. More generally speaking, the primary purpose is to handle updating/inserting data in a master list.
 * Usage: Call the handleStashInsert function for each page change and item update. This will ensure that the stash state variable will always have a fresh copy of your paginated items.
 */
export function useStash<T extends { id: number | string }>(items: T[]): IUseStash<T> {
  const [stash, setStash] = useState(items)
  function handleStashInsert(items: T[]) {
    const newStash = [...stash]
    for (const item of items) {
      const indexOfItemToUpdate = newStash.findIndex((stashItem) => stashItem.id === item.id)
      indexOfItemToUpdate === -1 ? newStash.push(item) : (newStash[indexOfItemToUpdate] = item)
    }
    setStash(newStash)
  }
  return [stash, handleStashInsert]
}
